module.exports = __webpack_public_path__ + "static/media/number_text_input.09fcdf2d.PNG";